/* Roy Riff — test ride: registra el lead (form contact) y abre WhatsApp prellenado.
   Mismo flujo que el sitio anterior: el lead SIEMPRE queda; WhatsApp abre igual aunque falle el POST. */
(function () {
  const form = document.getElementById('rr-testride-form');
  if (!form) return;

  const fab = document.querySelector('.rr-wa-fab');
  const waNumber = (fab && (fab.href.match(/wa\.me\/(\d+)/) || [])[1]) || '5493812006514';

  form.addEventListener('submit', function (e) {
    const name = (form.querySelector('[name="contact[Nombre]"]') || {}).value || '';
    const bike = (form.querySelector('[name="contact[Bici]"]') || {}).value || '';
    const zone = (form.querySelector('[name="contact[Zona]"]') || {}).value || '';
    const msg =
      'Hola! Soy ' + name + ' y quiero coordinar un test ride de la ' + bike + ' (' + zone + ')';
    const waUrl = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);

    // Abrir WhatsApp en una pestaña nueva; el form sigue su POST normal (el lead queda en Shopify).
    try {
      window.open(waUrl, '_blank', 'noopener');
    } catch (err) {
      /* si el popup se bloquea, el form igual se envía */
    }
  });
})();
